import { awsApiInstance } from '../api/aws-api';

import { ITerminalInsertUpdate, IPostTerminalResponse } from '../models/terminal.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Posts new termainl data to AWS
 * 
 * @param {ITerminalInsertUpdate} terminal the terminald data
 * 
 * @returns {IPostTerminalResponse} the api response | error 
 */
export const awsPostNewTerminal = async (terminal: ITerminalInsertUpdate): Promise<IPostTerminalResponse> => {
  try {
    const { data } = await awsApiInstance.post('/terminal', terminal);

    return data;
  } catch (error) {
    handleRouteError(error, 'Error creating new terminal');
    throw(error);
  }
}